/**
 *
 * @param text que será verificado para retirar os acentos.
 * @returns palavras sem acentos.
 */
export const removeAccents = (text: string): string => {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
};
